import { __assign, __awaiter, __generator } from "tslib";
import { resolveConfig, } from '@office-start/config-resolver-service';
import { isUwp } from '@office-start/device-detection-utility';
import { appListToFileTypeSet } from './helpers/appListToFileTypeSet';
import { isValidAppVersion } from './helpers/isValidAppVersion';
export function executeCapabilitiesDataFlow(options) {
    var _a, _b, _c, _d, _e, _f;
    return __awaiter(this, void 0, void 0, function () {
        var capabilitiesConfig, isPWA;
        return __generator(this, function (_g) {
            switch (_g.label) {
                case 0: return [4 /*yield*/, resolveConfig('capabilities', options)];
                case 1:
                    capabilitiesConfig = _g.sent();
                    if (!capabilitiesConfig) {
                        throw new Error('Cannot parse CapabilitiesConfig');
                    }
                    // As we are waiting for a couple of fixes before lighting up the Store in HWA. These fixes are now
                    // in build 18.2205.1091.0 which has been rolled out to internal traffic and starting to rollout to small
                    // percentage of external users. We're depending on these fixes, we need to gate the Store experience
                    // behind this build (i.e. if build >= 18.2205.1091.0 show Store, if not don't show Store).
                    // As the work to enable something part of the flight configuration will require more changes,
                    // until then adding build gate here.
                    if (capabilitiesConfig.storeAppEnabled &&
                        capabilitiesConfig.pwaEnabled &&
                        isUwp()) {
                        isPWA = (_a = Windows === null || Windows === void 0 ? void 0 : Windows.Security.Authentication.Web.Core.WebAuthenticationCoreManager) === null || _a === void 0 ? void 0 : _a.findAllAccountsAsync;
                        capabilitiesConfig.storeAppEnabled =
                            !!isPWA &&
                                ((_f = (_e = (_d = (_c = (_b = Windows.Foundation) === null || _b === void 0 ? void 0 : _b.Metadata) === null || _c === void 0 ? void 0 : _c.ApiInformation) === null || _d === void 0 ? void 0 : _d.isMethodPresent) === null || _e === void 0 ? void 0 : _e.call(_d, 'Windows.Security.Authentication.Web.Core.WebAuthenticationCoreManager', 'FindAllAccountsAsync')) !== null && _f !== void 0 ? _f : false) &&
                                isValidAppVersion({
                                    build: 1091,
                                    major: 18,
                                    minor: 2205,
                                    revision: 0,
                                });
                    }
                    return [2 /*return*/, __assign(__assign({}, capabilitiesConfig), { startPageApps: appListToFileTypeSet(capabilitiesConfig.startPageAppsArray), wacHostApps: appListToFileTypeSet(capabilitiesConfig.wacHostAppsArray), isPwaInUwp: capabilitiesConfig.pwaEnabled && isUwp() })];
            }
        });
    });
}
//# sourceMappingURL=executeCapabilitiesDataFlow.js.map